import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const ArrowFromToIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "ArrowFromToIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M5.14077 15.927C5.14077 15.4883 5.4958 15.1333 5.93455 15.1333L18.0661 15.1333C18.5048 15.1333 18.8599 15.4883 18.8599 15.927C18.8599 16.3658 18.5048 16.7208 18.0661 16.7208L5.93455 16.7208C5.4958 16.7208 5.14077 16.3658 5.14077 15.927Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.2817 19.2061C14.2817 19.0146 14.3499 18.8231 14.4894 18.6712L16.9917 15.927L14.4894 13.1806C14.1918 12.8558 14.2166 12.355 14.5406 12.0589C14.8646 11.7636 15.3669 11.7868 15.6615 12.1108L18.6521 15.3922C18.9281 15.696 18.9281 16.1596 18.6521 16.4619L15.6615 19.7409C15.3669 20.0649 14.8646 20.0882 14.5406 19.7928C14.3685 19.6363 14.2817 19.4215 14.2817 19.2061Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M5.14077 8.07295C5.14077 7.6342 5.4958 7.27917 5.93455 7.27917L18.0661 7.27917C18.5048 7.27917 18.8599 7.6342 18.8599 8.07295C18.8599 8.51171 18.5048 8.86674 18.0661 8.86674L5.93455 8.86674C5.4958 8.86674 5.14077 8.51171 5.14077 8.07295Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M5.14077 8.07295C5.14077 7.88148 5.21054 7.68924 5.34852 7.53809L8.33915 4.25908C8.63373 3.93506 9.13603 3.9118 9.46005 4.20716C9.78563 4.50173 9.80733 5.00559 9.51122 5.32883L7.00895 8.07297L9.51122 10.8186C9.80579 11.1427 9.78409 11.645 9.46005 11.9403C9.13602 12.2357 8.63371 12.2124 8.33915 11.8884L5.34852 8.60784C5.21054 8.45591 5.14077 8.26441 5.14077 8.07295Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default ArrowFromToIcon;
